import { Injectable } from '@angular/core';

import { MessageEnvelope } from '@cds/push';
import {
    BetBuilderSubscription,
    FixtureSlimSubscription,
    GameSubscription,
    OptionMarketSubscription,
    ParticipantMarketSubscription,
} from '@frontend/sports/content-distribution/feature';

export interface CdsSubscription {
    callback: (message: MessageEnvelope) => void;
    key: string[];
}

@Injectable({ providedIn: 'root' })
export class CdsSubscriptionFactory {
    createGameSubscription(context: string[], fixtureId: string, marketId: string, lang: string): CdsSubscription {
        return new GameSubscription(context, fixtureId, marketId, lang, (msg) => {});
    }

    createOptionMarketSubscription(context: string[], fixtureId: string, marketId: string, lang: string): CdsSubscription {
        return new OptionMarketSubscription(context, fixtureId, marketId, lang, (msg) => {});
    }

    createFixtureSlimSubscription(context: string[], fixtureId: string, lang: string): CdsSubscription {
        return new FixtureSlimSubscription(context, fixtureId, lang, (msg) => {});
    }

    createParticipantMarketSubscription(context: string[], fixtureId: string, participant: string, lang: string): CdsSubscription {
        return new ParticipantMarketSubscription(context, fixtureId, participant, lang, (msg) => {});
    }

    createBetBuilderSubscription(context: string[]): CdsSubscription {
        return new BetBuilderSubscription(context, (msg) => {});
    }
}
